import { AlertBanner } from "@saviynt/design-system";
import { type IntlShape, useIntl } from "react-intl";
import {
  ACTION_DELETE,
  ACTION_DISABLEACCOUNT,
} from "../../../constants/policies.constants";
import { type AlertType, useAlert } from "../context/AlertContext";

const DESTRUCTIVE_ACTIONS: ReadonlySet<string> = new Set([
  ACTION_DELETE,
  ACTION_DISABLEACCOUNT,
]);

function getSuccessTitle(intl: IntlShape): string {
  return intl.formatMessage({
    defaultMessage: "Thanks!",
    description: "Thanks! Alert Title",
    id: "QWYcyr",
  });
}

function getSuccessDescription(
  intl: IntlShape,
  alertType: AlertType | null,
): string {
  if (alertType && DESTRUCTIVE_ACTIONS.has(alertType)) {
    return intl.formatMessage({
      defaultMessage:
        "Your request is in. We'll create your request ID shortly",
      description: "Success message shown after deletion request is submitted",
      id: "9m6XiZ",
    });
  }
  return intl.formatMessage({
    defaultMessage: "Your request is in. We'll create your ticket(s) shortly",
    description:
      "Success message shown after ticket creation request is submitted",
    id: "MYDGFc",
  });
}

export default function ActionResultBanner() {
  const intl = useIntl();
  const { isAlertVisible, alertType, alertKind, message, hideAlert } =
    useAlert();

  if (!isAlertVisible) return null;

  const isSuccess = alertKind === "Success";

  return (
    <AlertBanner
      kind="high"
      colorTheme={alertKind}
      title={isSuccess ? getSuccessTitle(intl) : ""}
      description={isSuccess ? getSuccessDescription(intl, alertType) : message}
      isVisible={isAlertVisible}
      onCancel={hideAlert}
      isColonVisible={false}
      isFloating
      position={{ type: "fixed", top: "4.25rem" }}
      shouldAutoDismiss
      autoDismissDelay={5000}
      dataTestId="Policies-Findings-success-alert"
    />
  );
}
